/* eslint no-use-before-define: 0 */

import Rx from "rxjs/Rx";
import $ from "jquery";
import { SearchPageTypeFilterComponent } from "./search-page-type-filter.component";
import { typeFilterClicked$ } from "./base-type-filter.component";
import { FrontPageTypeFilterComponent } from "./front-page-type-filter.component";

export const allSearchTypeFiltersDisabledSource = new Rx.Subject();
export const allSearchTypeFiltersDisabled$ = allSearchTypeFiltersDisabledSource.asObservable();

/*
 * - Initializes TypeFilterComponent(s)
 * - Sets initial vistual selection for them
 * - Tracks selection of TypeFilterComponent(s) via lastTypeFilterIndex variable
 */
export class TypeFiltersPanelComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every TypeFilterPanelComponent class instance.
     */
    constructor(node, isFrontPageComponent, redirectionLinkBase) {
        this.node = node;

        this.typeFilterComponents = [];
        this.lastTypeFilterIndex = -1;
        this.isFrontPageComponent = isFrontPageComponent;
        this.selectedFilter = null;
        if (this.isFrontPageComponent) {
            this.redirectionLinkBase = redirectionLinkBase;
        }

        // comes from HTML arguments
        this.selectedIndexByDefault = null;

        this.initialize();
    }

    /**
     * @returns {Object} - selected BaseTypeFilterComponent instance or null
     */
    get selectedTypeFilter() {
        if (this.lastTypeFilterIndex !== null && this.lastTypeFilterIndex >= 0) {
            return this.typeFilterComponents[this.lastTypeFilterIndex];
        }

        return null;
    }

    initialize() {
        if (this.node) {
            this.parseArgs();
            this.initTypeFilterComponents();
            this.subscribeOnTypeFilterClicked();
        }
    }

    subscribeOnTypeFilterClicked() {
        typeFilterClicked$.subscribe((newSelectedFilter) => {
            if (this.selectedFilter != null) {
                this.selectedFilter.setPassiveState();
            }
            if (newSelectedFilter.index !== this.lastTypeFilterIndex) {
                this.lastTypeFilterIndex = newSelectedFilter.index;
                newSelectedFilter.setActiveState();
                this.selectedFilter = newSelectedFilter;
            } else {
                this.lastTypeFilterIndex = -1;
                if (this.selectedFilter instanceof SearchPageTypeFilterComponent) {
                    allSearchTypeFiltersDisabledSource.next();
                }
                this.selectedFilter = null;
            }
        });
    }

    setDefaultSelection() {
        const urlSelectedFilterIndexParameterValue = parseInt(getParameterByName("activeTypeFilterIndex"), 10);

        // eslint-disable-next-line no-restricted-properties
        const defaultSelectedFilterIndex = !window.isNaN(urlSelectedFilterIndexParameterValue)
            ? urlSelectedFilterIndexParameterValue
            : this.selectedIndexByDefault;
        if (isInteger(defaultSelectedFilterIndex) && defaultSelectedFilterIndex >= 0) {
            this.typeFilterComponents[defaultSelectedFilterIndex].node.click();
        }

        function getParameterByName(name) {
            const url = window.location.href;
            // eslint-disable-next-line no-useless-escape
            const fixedName = name.replace(/[\[\]]/g, "\\$&");
            const regex = new RegExp(`[?&]${fixedName}(=([^&#]*)|&|#|$)`);


            const results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return "";
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        function isInteger(x) {
            return x === parseInt(x, 10);
        }
    }

    initTypeFilterComponents() {
        const scope = this;
        if (this.isFrontPageComponent) {
            this.node.find(".custom-type-filter-component").each(function createFrontPageTypeFilter() {
                scope.typeFilterComponents.push(new FrontPageTypeFilterComponent($(this), scope.redirectionLinkBase));
            });
        } else {
            this.node.find(".custom-type-filter-component").each(function createSearchPageTypeFilter() {
                scope.typeFilterComponents.push(new SearchPageTypeFilterComponent($(this)));
            });
        }
    }

    parseArgs() {
        this.selectedIndexByDefault = parseInt(this.node.data("selected-index"), 10);
    }
}
